import React from 'react';
import { Modal, ModalBody } from 'reactstrap';
import { BsX } from 'react-icons/bs';
import manutencaoImg from '../../assets/imgs/manutencao.png';
import './styles.css';

interface WelcomeModalProps {
  isOpen: boolean;
  toggle: () => void;
}

const WelcomeModal: React.FC<WelcomeModalProps> = ({ isOpen, toggle }) => {

  return (
    <Modal 
      isOpen={isOpen} 
      toggle={toggle} 
      centered
      size="lg"
      className="welcome-modal image-modal"
    >
      <ModalBody className="image-modal-body p-0">
        <button 
          type="button" 
          className="btn-close-image" 
          onClick={toggle}
          aria-label="Fechar"
        >
          <BsX size={24} />
        </button>
        <img 
          src={manutencaoImg} 
          alt="Aviso de Manutenção" 
          className="maintenance-image"
        />
      </ModalBody>
    </Modal>
  );
};

export default WelcomeModal;